import ThemeRegistry from "../registry";
import config from "./config";

export function init() {
  ThemeRegistry.register("boost", {config});
}
